import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { EditUserProfileComponent } from './component/user profile/edit-user-profile/edit-user-profile.component';
import { AuthorizationGuard } from './service/auth-guard/authorization-guard.service';
import { UnassignedComponent } from './component/assigned-trips/unassigned/unassigned.component';
import { NewTripComponent } from './component/assigned-trips/new-trip/new-trip.component';
import { NotificationDetailsComponent } from './notification/notification-details/notification-details.component';
import { MemberListComponent } from './component/members/member-list/member-list.component';
import { CreateMemberComponent } from './component/members/create-member/create-member.component';
import { ZDatesComponent } from './component/z-dates/z-dates.component';
import { StandingOrdersV2Component } from './component/assigned-trips/standing-orders-v2/standing-orders-v2.component';
import { UserRoles } from './service/menu-service/menu.service';
import { UnAuthorizationGuard } from './service/non-auth-guard/unauthorization-guard.service';
import { StaffListComponent } from './component/staffs/staff-list/staff-list.component';
import { AddStaffComponent } from './component/staffs/add-staff/add-staff.component';
import { OperationsComponent } from './component/assigned-trips/operations/operations.component';
import { AuthTokenComponent } from './component/auth-token/auth-token.component';
import { GanttChartComponent } from './component/assigned-trips/gantt-chart/gantt-chart.component';
import { TripReportsComponent } from './component/reports/trip-reports/trip-reports.component';
import { OtpListComponent } from './component/otp/otp-list/otp-list.component';
import { GanttChartV2Component } from './component/assigned-trips/gantt-chart-v2/gantt-chart-v2.component';
import { UnsavedChangesGuard } from './service/unsaved-changes-guard/unsaved-changes.guard';
import { PublicOperationsComponent } from './component/assigned-trips/public-operation/public-operations/public-operations.component';
import { PublicOperationHandshakeComponent } from './component/assigned-trips/public-operation/public-operation-handshake/public-operation-handshake.component';
import { PublicGuard } from './service/public-guard/public.guard';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { TwoFactorAuthenticationComponent } from './component/two-factor-authentication/two-factor-authentication.component';
import { TwoFactorAuthenticationGuard } from './service/two-factor-guard/two-factor-guard.service';
import { FacilityComponent } from './component/facility/facility.component';
import { PatientComponent } from './component/placement/patient/patient.component';
import { ReservationsComponent } from './component/placement/reservations/reservations.component';
import { CreateAssistComponent } from './component/placement/assist/create-assist/create-assist.component';
import { AssistListComponent } from './component/placement/assist/assist-list/assist-list.component';
import { AddPatientComponent } from './component/placement/add-patient/add-patient.component';
import { ProposalDetailModalComponent } from './component/placement/proposal/proposal-detail-modal/proposal-detail-modal.component';
import { MessagesComponent } from './component/placement/messages/messages.component';






const routes: Routes = [
  {
    path: 'login', component: SignInComponent, canActivate: [UnAuthorizationGuard]
  },
  {
    path: 'verify-mfa', component: TwoFactorAuthenticationComponent, canActivate: [TwoFactorAuthenticationGuard]
  },
  {
    path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [UnAuthorizationGuard]
  },

  {
    path: 'password/reset/:token/:role', component: ResetPasswordComponent, canActivate: [UnAuthorizationGuard]
  },

  { path: '', redirectTo: '/trips', pathMatch: 'full' },

  { path: 'auth-token/:token', component: AuthTokenComponent },

  {
    path: 'operations', component: OperationsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  {
    path: 'public/operations', component: PublicOperationsComponent, canActivate: [PublicGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  {
    path: 'handshake', component: PublicOperationHandshakeComponent, data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },

  {
    path: 'trips', component: UnassignedComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  {
    path: 'placement', component: FacilityComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/patient', component: PatientComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/reservations', component: ReservationsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/assists', component: AssistListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/messages', component: MessagesComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/proposals/:id', component: ProposalDetailModalComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/assists/list', component: AssistListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/assist-list', component: AssistListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/assists/create', component: CreateAssistComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/create-assist', component: CreateAssistComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/patient/add', component: AddPatientComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/:clientId/patient/add', component: AddPatientComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'placement/patient/:id/edit', component: AddPatientComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE]
    }
  },
  {
    path: 'trips/tripsheet', component: GanttChartV2Component, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  // {
  //   path: 'trips/tripsheet/v2', component: GanttChartComponent, canActivate: [AuthorizationGuard], data: {
  //     role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
  //   }
  // },
  {
    path: 'trips/new', component: NewTripComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'trips/:id/edit', component: NewTripComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },

  {
    path: 'credentialing/staff', component: StaffListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'credentialing/staff/add', component: AddStaffComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'credentialing/staff/:id/edit', component: AddStaffComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },

  {
    path: 'standing-orders', component: StandingOrdersV2Component, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },
  {
    path: 'credentialing/members', component: MemberListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'credentialing/members/add', component: CreateMemberComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },
  {
    path: 'credentialing/members/:id/edit', component: CreateMemberComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },

  {
    path: 'reports', component: TripReportsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },

  {
    path: 'profile', component: EditUserProfileComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },

  {
    path: 'notifications', component: NotificationDetailsComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS]
    }
  },

  {
    path: 'otp', component: OtpListComponent, canActivate: [AuthorizationGuard], data: {
      role: [UserRoles.CORPORATE, UserRoles.FULL_ACCESS, UserRoles.TRANSPORTATION_COORDINATOR]
    }
  },


  { path: '**', component: ZDatesComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
